import { Injectable } from "@angular/core";

declare var toastr: any;

@Injectable()
export class LoggerService {
	constructor() {}

	public logError(message) {
		this.logIt(message, null, null, true, "error");
	}

	private logIt(message, data, source, showToast, toastType) {
		if (!message) {
			return;
		}
		toastr.options.timeOut = 4000;
		toastr.options.positionClass = "toast-bottom-right";

		source = source ? "[" + source + "] " : "";
		if (showToast) {
			if (toastType === "error") {
				toastr.error(message);
			} else if (toastType === "warning") {
				toastr.warning(message);
			} else if (toastType === "success") {
				toastr.success(message);
			} else {
				toastr.info(message);
			}
		}
	}
}
